import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import Navbar from "../components/Navbar";
import MemoryTimeline from "../components/MemoryTimeline";
import { Switch } from "../components/ui/switch";
import { ArrowLeft, Eye, Heart } from "lucide-react";

const isReleased = (m, deceased) => {
  const rt = m.release_type;
  const now = new Date();
  if (rt === "immediate") return true;
  if (rt === "death") return deceased;
  if (rt === "date" || rt === "event") {
    if (m.release_date) return now >= new Date(m.release_date);
    return deceased;
  }
  return false;
};

const AnteprimaCapsula = () => {
  const [memories, setMemories] = useState(null);
  const [afterDeath, setAfterDeath] = useState(true);
  const [cover, setCover] = useState(null);
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/memories").then((r) => setMemories(r.data)).catch(() => setMemories([]));
    api.get("/profile").then((r) => setCover(r.data.cover_image)).catch(() => {});
  }, []);

  const visible = (memories || []).filter((m) => isReleased(m, afterDeath));
  const hidden = (memories || []).length - visible.length;

  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="max-w-4xl mx-auto px-6 py-10 fade-in">
        <button onClick={() => navigate("/ricordi")} className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-[#2C2A29] mb-6 transition-colors" data-testid="anteprima-back">
          <ArrowLeft className="w-4 h-4" /> Torna al libro
        </button>

        <div className="bg-[#FBEDE7] border border-[#f0d5c9] rounded-2xl p-5 mb-8 flex flex-col sm:flex-row sm:items-center gap-4" data-testid="anteprima-banner">
          <div className="flex items-start gap-3 flex-1">
            <Eye className="w-5 h-5 shrink-0 mt-0.5 text-[#8a4a35]" />
            <p className="text-sm text-[#8a4a35]">Anteprima — così i tuoi cari vedranno la tua Capsula del Tempo, secondo le regole di rilascio che hai scelto. Solo tu stai vedendo questa pagina.</p>
          </div>
          <div className="flex items-center gap-3 shrink-0 bg-white/60 rounded-full pl-4 pr-2 py-1.5">
            <span className="text-sm flex items-center gap-1.5 text-[#2C2A29]"><Heart className="w-4 h-4 text-[#8A6D9C]" /> Dopo la scomparsa</span>
            <Switch checked={afterDeath} onCheckedChange={setAfterDeath} data-testid="anteprima-simulate-switch" />
          </div>
        </div>

        {memories === null ? (
          <p className="text-muted-foreground">Caricamento…</p>
        ) : (memories || []).length === 0 ? (
          <p className="text-muted-foreground">Non hai ancora ricordi da mostrare nella capsula.</p>
        ) : visible.length === 0 ? (
          <div className="text-center py-16 bg-white rounded-3xl border border-border" data-testid="anteprima-empty">
            <Eye className="w-8 h-8 text-muted-foreground mx-auto mb-4" />
            <p className="text-muted-foreground max-w-sm mx-auto">
              {afterDeath
                ? "Nessun ricordo sarebbe ancora visibile in questo momento."
                : "Prima della scomparsa i tuoi cari non vedrebbero ancora nulla. Attiva «Dopo la scomparsa» per l'anteprima completa."}
            </p>
          </div>
        ) : (
          <>
            {hidden > 0 && (
              <p className="text-sm text-muted-foreground mb-6" data-testid="anteprima-hidden-count">
                {hidden} {hidden === 1 ? "ricordo è ancora nascosto" : "ricordi sono ancora nascosti"} con questa simulazione.
              </p>
            )}
            <MemoryTimeline memories={visible} ownerName={user?.name || "te"} coverImage={cover} />
          </>
        )}
      </main>
    </div>
  );
};

export default AnteprimaCapsula;
